import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/rols.svg',
})
export class RolsComponent {}
